import Chip from '@mui/joy/Chip';
import type { TicketStatus, TicketPriority } from '../../types/support';

const STATUS_CONFIG: Record<TicketStatus, { label: string; color: 'success' | 'warning' | 'danger' | 'neutral' | 'primary' }> = {
  open: { label: 'Open', color: 'primary' },
  in_progress: { label: 'In Progress', color: 'warning' },
  waiting_on_customer: { label: 'Waiting', color: 'neutral' },
  resolved: { label: 'Resolved', color: 'success' },
  closed: { label: 'Closed', color: 'neutral' },
};

const PRIORITY_CONFIG: Record<TicketPriority, { label: string; color: 'success' | 'warning' | 'danger' | 'neutral' }> = {
  low: { label: 'Low', color: 'neutral' },
  normal: { label: 'Normal', color: 'success' },
  high: { label: 'High', color: 'warning' },
  urgent: { label: 'Urgent', color: 'danger' },
};

export function StatusChip({ status }: { status: TicketStatus }) {
  const cfg = STATUS_CONFIG[status] ?? { label: status, color: 'neutral' as const };
  return <Chip size="sm" color={cfg.color} variant="soft">{cfg.label}</Chip>;
}

export function PriorityChip({ priority }: { priority: TicketPriority }) {
  const cfg = PRIORITY_CONFIG[priority] ?? { label: priority, color: 'neutral' as const };
  return <Chip size="sm" color={cfg.color} variant="outlined">{cfg.label}</Chip>;
}
